import { useTranslation } from 'react-i18next';
import { useDraggable } from '@dnd-kit/core';

import { cn } from 'support/helpers/cn/cn';
import { Checkbox } from 'components/Form/Checkbox/Checkbox';

import { getLineItemDisplay } from '../../helpers/lineItemDisplay';
import { LineItemEntry } from '../../types';
import { ItemActionsMenu } from '../ItemActionsMenu/ItemActionsMenu';
import { ProductCardContent } from '../ProductCardContent/ProductCardContent';

export const ProductCard = ({
  product,
  available,
  total,
  isSelected,
  onToggleSelect,
  onMoveTo,
}: {
  product: LineItemEntry;
  available: number;
  total: number;
  isSelected: boolean;
  onToggleSelect: () => void;
  onMoveTo: () => void;
}) => {
  const { t } = useTranslation();
  const { name } = getLineItemDisplay(product.row, t);
  const isPlaced = available <= 0;
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: product.id,
    disabled: isPlaced,
    data: { kind: 'product', lineItemId: product.id },
  });
  return (
    <div
      ref={setNodeRef}
      {...(isPlaced ? {} : { ...listeners, ...attributes })}
      className={cn(isPlaced ? '' : 'cursor-grab active:cursor-grabbing', isDragging ? 'opacity-40' : '')}
    >
      <ProductCardContent
        entry={product}
        available={available}
        total={total}
        isSelected={isSelected}
        leading={
          isPlaced ? undefined : (
            <Checkbox
              checked={isSelected}
              onChange={onToggleSelect}
              onClick={(event) => event.stopPropagation()}
              onPointerDown={(event) => event.stopPropagation()}
              aria-label={name || product.id}
            />
          )
        }
        trailing={isPlaced ? undefined : <ItemActionsMenu onMoveTo={onMoveTo} />}
      />
    </div>
  );
};
